import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import 'normalize.css';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
export default function SolarisThemeProvider(props) {
    return (_jsx(ThemeProvider, { theme: props.theme, children: _jsxs(_Fragment, { children: [_jsx(GlobalStyles, {}), props.children] }) }));
}
const GlobalStyles = createGlobalStyle `
    body, html, #root {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        font-size: ${(props) => props.theme.typography.md};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    code {
        font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
            monospace;
    }
    
    button, p, h1, h2, h3, h4, h5, body, html, input, textarea, #root {
        font-family: ${(props) => props.theme.typography.FontFamily};
    }
    
    * {
        box-sizing: border-box;
    }
`;
//# sourceMappingURL=SolarisThemeProvider.js.map